// offset
export const OFFSET_WORK_LOG = "75";
export const OFFSET_TOOL_SET = "90";
export const OFFSET_SIDE_PROJECTS = "70";
